export default __webpack_public_path__ + "static/media/sr.5de7e873.svg";